import {
  Directive,
  Input
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  Validator
} from '@angular/forms';

@Directive({
  selector : '[worMatchValidator]',
  providers: [
    {
      multi      : true,
      provide    : NG_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: MatchValidator
    }
  ]
})
export class MatchValidator implements Validator {
  @Input('mustMatch') valueToMatch : string;
  @Input('worMatchValidator') value: string;

  validate ( control: AbstractControl ) : { [ key: string ] : any } {
    if (!this.valueToMatch || !control.value) {
      return null;
    }

    if ( control.value !== this.valueToMatch ) {
      return { match: true };
    }

    return null;
  }
}